import React from 'react';
import Modal from '../ui/Modal/Modal';
import { useTranslation } from '../../utils/i18n';
import { Icons } from '../Icons';
import './TechnicalGuideModal.css';

/**
 * TechnicalGuideModal Component
 * 
 * Shows a guide when users switch to Technical UI for the first time.
 * Explains what Technical UI is and offers option to go back or continue.
 */
const TechnicalGuideModal = ({ isOpen, onGoBack, onContinue }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onGoBack}
      title={t('technicalGuide.title', 'Welcome to Technical UI')}
      size="md"
      closeOnBackdropClick={false}
      primaryActionLabel={t('technicalGuide.continue', 'Continue to Technical UI')}
      onPrimaryAction={onContinue}
      secondaryActionLabel={t('technicalGuide.goBack', 'Go Back to Customer UI')}
      onSecondaryAction={onGoBack}
      className="technical-guide-modal"
    >
      <div className="technical-guide-content">
        <div className="technical-guide-icon">
          <Icons.Settings size={48} />
        </div>
        
        <div className="technical-guide-description">
          <p>
            {t('technicalGuide.description', 'This is the Technical UI, designed for users who want to resell products, bundle services, or host their own SaaS solutions on B-esper.')}
          </p>
        </div>

        <div className="technical-guide-recommendation">
          <p>
            {t('technicalGuide.recommendation', 'If you are not reselling or hosting on B-esper, we recommend going back to the Customer UI for a simpler experience focused on using products.')}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default TechnicalGuideModal;









